export const CHROMA_COMPOSITE_REQUEST = "CHROMA_COMPOSITE_REQUEST";
export const CHROMA_COMPOSITE_SUCCESS = "CHROMA_COMPOSITE_SUCCESS";
export const CHROMA_COMPOSITE_FAILED = "CHROMA_COMPOSITE_FAILED";
